import { Component, Input, OnInit } from '@angular/core';
import { PagoService } from '../../../../services/database/pago.service';
import { TranslateService } from '@ngx-translate/core';
import { DEFAULT_DATE_FORMAT } from 'lib-base';
import { IGetPagoInfo } from '../../../../shared/interfaces/database/recaudo';
import { CommonModule } from '@angular/common';
import { SkeletonModule } from 'primeng/skeleton';
import { firstValueFrom, forkJoin } from 'rxjs';

@Component({
  selector: 'app-pago',
  standalone: true,
  imports: [CommonModule, SkeletonModule],
  templateUrl: './pago.component.html',
  styleUrl: './pago.component.scss'
})
export class PagoComponent implements OnInit {
  @Input() tramRegistroId !: number;

  isLoading: boolean = true;
  data !: IGetPagoInfo;
  readonly defaultDateFormat = DEFAULT_DATE_FORMAT;
  trans: any = {};

  constructor(private readonly _ps: PagoService, private readonly _t: TranslateService) {
  }

  ngOnInit(): void {
    this.translate();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
        razonSocial: this._t.get('common.razonSocial'),
        tipoIdentificacion: this._t.get('common.tipoIdentificacion'),
        identificacion: this._t.get('common.identificacion'),
        correo: this._t.get('common.correo'),
        telefono: this._t.get('common.telefono'),
        direccion: this._t.get('common.direccion'),
        pago: this._t.get('common.pago'),
        vigencia: this._t.get('common.vigencia'),
        periodo: this._t.get('common.periodo'),
        banco: this._t.get('common.banco'),
        medioPago: this._t.get('common.medioPago'),
        fechaPago: this._t.get('common.fechaPago'),
        impuesto: this._t.get('common.impuesto'),
        concepto: this._t.get('common.concepto'),
        nombreTramite: this._t.get('common.nombreTramite'),
        totalPago: this._t.get('common.totalPago'),
        valorAplicadoConcepto: this._t.get('common.valorAplicadoConcepto'),        
        informacionPago: this._t.get('msg.informacionPago')
      })
    );
  }

  getPagoInfo() {
    if (!this.tramRegistroId || this.data !== undefined) 
      return;
    this.isLoading = true;
    this._ps.getPagosInfo(this.tramRegistroId).subscribe({
      next: (data: IGetPagoInfo) => {
        this.data = data;
      }, complete: () => {
        this.isLoading = false;
      }
    });
  }
}
